var _g, _g2, _g3, _g4, _g5, _g6, _g7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPreviewErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17855"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17854"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31846",
    d: "M32 0A32 32 0 110 32 31.966 31.966 0 0132 0z",
    fill: "#ff6a4d"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17857"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17856"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31847",
    d: "M41.8 10l8.2 7.8v34.8a1.453 1.453 0 01-1.5 1.4h-33a1.453 1.453 0 01-1.5-1.4V11.4a1.453 1.453 0 011.5-1.4z",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17859"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17858"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31848",
    d: "M50 17.8h-8.2V10z",
    fill: "#d3d5dd"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17861"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17860"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31849",
    d: "M45 21a1 1 0 010 2H19a1 1 0 010-2z",
    fill: "#d3d5dd"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17863"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17862"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31850",
    d: "M45 26a1 1 0 010 2H19a1 1 0 010-2z",
    fill: "#d3d5dd"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17865"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17864"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31851",
    d: "M41 35l-7 7 7 7-2 2-7-7-7 7-2-2 7-7-7-7 2-2 7 7 7-7z",
    fill: "#f94646"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17867"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17866"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31852",
    d: "M36.8 16a1 1 0 010 2H19a1 1 0 010-2z",
    fill: "#d3d5dd"
  })))));
}

export default SvgPreviewErrorIcon;